import React from 'react';
import { Text, ActivityIndicator } from 'react-native';

import { useFonts } from 'expo-font'

const StyledText = props =>{

    let [fontsLoaded] = useFonts({
        "Mikhak": require('../assets/Fonts/Mikhak-Regular.ttf')
    })
    
    if (!fontsLoaded) return <Text {...props} > {props.children} </Text>
    else return <Text {...props} style={{...Styles.styledText, ...props.style}} >{props.children}</Text> 
    // return <Text {...props} > {props.children} </Text>

    // return <Text {...props} style={{...Styles.styledText, ...props.style}} >{props.children}</Text>
};

let Styles = {
    styledText: {
        fontFamily: "Mikhak"
    }
};
// const styles = StyleSheet.create({
//     card: {
//         padding: 20,
//         margin:10,
//         backgroundColor: '#ffffff',
//         shadowColor: 'black',
//         shadowOffset: {width: 0, height:2},
//         shadowRadius: 6,
//         shadowOpacity: 0.26,
//         elevation: 10,
//         borderRadius: 15,
//     },
// });

export default StyledText;